import React from 'react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { familiarSituations } from '../../data/content';
export function SoundFamiliar() {
  return <section className="bg-paper-50 px-5 py-14 sm:px-8 sm:py-20" data-id="element-249" data-mp="mqmh7whvdjwi">
      <div className="mx-auto max-w-4xl" data-id="element-250" data-mp="msfnhaokm23z">
        <SectionHeading tone="light" title="Does This Sound Familiar?" subtitle="If you’ve ever experienced even one of these situations, this system was designed for you." data-id="element-251" data-mp="qqww5ynn3kni" />

        <ul className="mt-9 space-y-4" data-id="element-252" data-mp="hrrzkxvn21dz">
          {familiarSituations.map(item => <li key={item.title} className="rounded-2xl border-l-4 border-teal-400 bg-white p-4 shadow-[0_1px_2px_rgba(4,18,27,0.05)] sm:p-6" data-id="element-253" data-mp="3359c14h3p7z">
              <h3 className="text-[15px] font-extrabold leading-snug text-ink-900 sm:text-lg" data-id="element-254" data-mp="3q6a2ymamwsr9">
                {item.title}
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-ink-600 sm:text-base" data-id="element-255" data-mp="3v53foci3kfqd">
                {item.body}
              </p>
            </li>)}
        </ul>

        <div className="mt-10 rounded-2xl bg-ink-900 p-6 text-center sm:p-8" data-id="element-256" data-mp="ojfhmbcz05hu">
          <p className="font-display text-lg font-bold uppercase leading-tight tracking-[0.08em] text-white sm:text-2xl" data-id="element-257" data-mp="12kruuf0qxt01">
            If you said “yes” to just one of these…
          </p>
          <p className="mt-2 font-display text-xl font-bold uppercase leading-tight tracking-[0.06em] text-teal-300 sm:text-3xl" data-id="element-258" data-mp="9vb5jq8fas81">
            The Master System of TRT™ was built for you.
          </p>
          <div className="mx-auto mt-6 max-w-md" data-id="element-259" data-mp="jl4861ql7x05">
            <CtaButton label="Get the Master System of TRT™" subLabel="Instant Access · One-Time Payment · USD 27" data-id="element-260" data-mp="jmyunkhibx6c" />
          </div>
        </div>
      </div>
    </section>;
}